import { render, staticRenderFns } from "./PageWeHaveGotYourPhoto.vue?vue&type=template&id=13ce5962"
import script from "./PageWeHaveGotYourPhoto.vue?vue&type=script&lang=js"
export * from "./PageWeHaveGotYourPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports